import { render, staticRenderFns } from "./responsive_pagination.vue?vue&type=template&id=5b239372&scoped=true"
import script from "./responsive_pagination.vue?vue&type=script&lang=js"
export * from "./responsive_pagination.vue?vue&type=script&lang=js"
import style1 from "./responsive_pagination.vue?vue&type=style&index=1&id=5b239372&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b239372",
  null
  
)

export default component.exports